<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('organization_profile.remove_admin_modal.title')"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <p>{{ $t('organization_profile.remove_admin_modal.msg_no_longer_admin', [adminName]) }}</p>
    </template>
    <template v-slot:footer>
      <span class="dialog-footer">
        <primary-button
          @click.native="handleRemove"
        >
          {{ $t('organization_profile.remove_admin_modal.yes_remove') }}
        </primary-button>
        <tertiary-button @click.native="handleCancelClick">
          {{ $t('organization_profile.remove_admin_modal.no_cancel') }}
        </tertiary-button>
      </span>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import { successMessage, warningMessage } from '@/utils/messages'

  export default {
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton
    },
    props: {
      organization: {
        type: Object,
        default: () => {}
      },
      adminRemoveId: {
        type: String
      },
      adminName: {
        type: String
      }
    },
    methods: {
      handleRemove() {
        this.$emit('closed')
        this.handleRemoveFromOrg()
      },
      handleCancelClick() {
        this.$emit('closed')
      },
      async handleRemoveFromOrg() {
        const userId = this.adminRemoveId;
        const organizationId = this.organization.id
        const organizationOnlyAdmin =  this.$store.getters['organization/organizationOnlyAdmin'](organizationId, userId)

        if(!organizationOnlyAdmin) {
          try {
            await this.$store.dispatch('organization/removeFromOrganization', {
              userId,
              organizationId
            })
            successMessage(this.$t('common.remove_user_from_system_success'))(this)
            return this.$store.dispatch('organization/getCurrentOrganizationAdmins')

          } catch {
            return warningMessage(this.$t('common.generic_error_message'))(this)
          }
        }

        return warningMessage(this.$t('organization_profile.admin_actions.user_id_only_admin'))(this)
      },
    }
  }
</script>

<style lang="scss" scoped>

  ::v-deep .el-dialog.elsa-modal .el-dialog__body {
    margin-bottom: 48px;
  }

  p {
    margin: 0;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    color: #EB5757;
  }

  .elsa-primary-button.el-button {

    &, &:hover {
      background: #EB5757 !important;
    }
  }

  .elsa-flat-button.el-button {
    color: #546873;
    opacity: 0.7;
    &:hover {
      color: #546873;
      opacity: 0.7;
      font-weight: 700;
    }
  }
</style>
